import apolloClient from 'api/apolloClient';
import { GET_ORG_AFFILIATION } from 'api/queries/aaaService';
import axios, { AxiosResponse } from 'axios';
import { FullAgency, SetUserOrfAffiliationParams } from 'types/aaaService';

export async function getOrgAffiliation(): Promise<FullAgency[]> {
  return (
    await apolloClient.query<{ getOrgAffiliationV2: FullAgency[] }>({
      query: GET_ORG_AFFILIATION,
      fetchPolicy: 'no-cache',
    })
  ).data.getOrgAffiliationV2;
}

export const setUserOrgAffiliation = async (params: SetUserOrfAffiliationParams): Promise<AxiosResponse<string>> => {
  const res = await axios.post(`https://${process.env.REACT_APP_API_BASE_URL}/aaa/Prod/setUserOrgAffiliation`, params, {
    withCredentials: true,
  });
  return res;
};
